/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { FormControl, Tooltip, FormControlLabel, Switch, Grid } from '@mui/material';
import { CustomStack } from 'modules/common/components';
import styles from 'modules/dashboard/components/tab-container/inner-filter/inner-filter.module.scss';
import InfoIcon from '@mui/icons-material/Info';
import { useSelector } from 'react-redux';
import { selectPmsTooltipIsDisplay } from '../../../../../selectors';
/**
 * PMS toggle switch component common for the dashboard component
 * @param {Boolean} disabled - State to disable toggle
 * @param {Boolean} value - Toggle value
 * @param {Function} onChange - Function to call when the toggle value changes
 * @returns
 */
const PmsToggle = ({ disabled, value, onChange, id = '' }) => {
  const pmsTooltipIsDisplay = useSelector(selectPmsTooltipIsDisplay);
  return (
    <CustomStack cssClassName={styles.innerFilter}>
      <FormControl sx={{ paddingTop: 3, paddingBottom: 3 }}>
        <Grid container justifyContent="space-between" className='pms'>
          <Tooltip title="Include PMS in addition to CRS bookings." placement="top">
            <FormControlLabel
              disabled={disabled}
              control={<Switch checked={value} onChange={onChange} id={id} />}
              label="Incl. PMS"
              sx={{
                width: 'fit-content',
                height: 10,
              }}
            />
          </Tooltip>
          {pmsTooltipIsDisplay && value && (
            <Tooltip
              color="primary"
              placement="top"
              title="PMS data for this property became available only midway through one of your selected date ranges, which may cause discontinuities in the visuals"
            >
              <InfoIcon />
            </Tooltip>
          )}
        </Grid>
      </FormControl>
    </CustomStack>
  );
};
//
export default PmsToggle;
